import type { BatchFixedSlot, BatchDynamicSlot } from "../../../../api/academyEnrolments/enrolmentsService";
import type { SelectedSlot } from "../useEnrolmentForm";

export function slotMatchesFixed(sel: SelectedSlot, batch: BatchFixedSlot): boolean {
  return (
    sel.startTime === batch.startTime &&
    sel.endTime === batch.endTime &&
    JSON.stringify([...(sel.days ?? [])].sort()) === JSON.stringify([...batch.days].sort())
  );
}

export function slotMatchesDynamic(sel: SelectedSlot, batch: BatchDynamicSlot): boolean {
  return (
    sel.day === batch.day &&
    sel.startTime === batch.startTime &&
    sel.endTime === batch.endTime
  );
}
